import { Col, Form, Input, Row } from "antd";
import type { UserInfoFormFields } from "@/types/common-form-fileds";

/**
 * 用户信息
 */
export function UserFormFields() {
  return (
    <div style={{ width: "100%" }}>
      <Row style={{ width: "100%" }} gutter={49}>
        <Col span={8}>
          <Form.Item<UserInfoFormFields> name="username" label="员工姓名">
            <Input disabled></Input>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<UserInfoFormFields> name="employeeCode" label="员工编号">
            <Input disabled></Input>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<UserInfoFormFields> name="createDate" label="创建日期">
            <Input disabled></Input>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<UserInfoFormFields> name="department" label="部门">
            <Input disabled></Input>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<UserInfoFormFields> name="postName" label="岗位">
            <Input disabled></Input>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<UserInfoFormFields> name="email" label="邮箱">
            <Input disabled></Input>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}
